import type { AppSettings } from '../types';
import type { AIProvider, ProviderContext } from './provider';
import { CodexProvider } from './codexProvider';
import { cloudComplete } from './cloudRunner';
import { cloudConfig } from '../config/cloud';
import { isTauri } from './tauri';

export * from './provider';
export { isTauri };

/**
 * Build the active provider. Same prompt/parse pipeline everywhere; only the
 * execution path differs by build:
 *  - Desktop (Tauri): the Codex CLI runs locally — private and offline-capable.
 *  - Hosted web (cloud build): every model call routes through the backend,
 *    which fronts Azure AI Foundry and meters the account's monthly credits.
 *    The browser never spawns a CLI or holds a model key.
 *  - Local web dev without cloud config: Codex via the Vite bridge.
 */
export function createProvider(settings: AppSettings): AIProvider {
  if (!isTauri() && cloudConfig.syncEnabled) {
    return new CodexProvider(settings, cloudComplete);
  }
  return new CodexProvider(settings);
}

export function providerContext(settings: AppSettings): ProviderContext {
  return {
    model: settings.defaultModel,
    promptVersion: settings.promptVersion,
    rubricVersion: settings.rubricVersion,
    webSearch: settings.enableWebSearch,
  };
}
